import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatTimeAgo(dateString, lang = 'en') {
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now - date) / 1000);
  
  const intervals = {
    ht: {
      year: 'ane',
      month: 'mwa',
      week: 'semèn',
      day: 'jou',
      hour: 'è',
      minute: 'min',
      now: 'kounye a'
    },
    en: {
      year: 'y',
      month: 'mo',
      week: 'w',
      day: 'd',
      hour: 'h',
      minute: 'm',
      now: 'now'
    }
  };
  
  const t = intervals[lang] || intervals.en;
  
  if (seconds < 60) return t.now;
  
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}${t.minute}`;
  
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}${t.hour}`;
  
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}${t.day}`;
  
  const weeks = Math.floor(days / 7);
  if (weeks < 4) return `${weeks}${t.week}`;
  
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}${t.month}`;
  
  const years = Math.floor(days / 365);
  return `${years}${t.year}`;
}

export function formatNumber(num) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
}

export function getInitials(name) {
  if (!name) return '?';
  return name
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function validateEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
}

export function validateUsername(username) {
  const re = /^[a-zA-Z0-9_]{3,20}$/;
  return re.test(username);
}

export function compressImage(file, maxWidth = 1200, quality = 0.8) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;
        
        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }
        
        canvas.width = width;
        canvas.height = height;
        
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        
        resolve(canvas.toDataURL('image/jpeg', quality));
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
}
